import { Button, Modal, Tag } from '@maxtropy/components';
import { apiV2RuleRuleListPost } from '@maxtropy/device-customer-apis-v2';
import { useRequest } from 'ahooks';
import React, { FC, MutableRefObject, useRef, useState } from 'react';
import styles from './index.module.scss';
import RuleModal, { RuleModalRef } from './RuleModal';

interface MultiRulesModalSelectProps {
  onChange?: (val?: number[]) => void;
  value?: number[];
  isEditing: boolean;
}

const MultiRulesModalSelect: FC<MultiRulesModalSelectProps> = props => {
  const { value, onChange, isEditing } = props;
  const ruleRef: MutableRefObject<RuleModalRef | null> = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const onClose = (e: React.MouseEvent<HTMLElement>, ruleId: number) => {
    e.preventDefault();
    Modal.confirm({
      title: '确定移除？',
      okText: '确定',
      onOk: async () => {
        const _ruleIds = value?.filter(id => id !== ruleId);
        onChange!(_ruleIds);
      },
    });
  };

  const onOk = () => {
    setIsModalVisible(false);
    const _ruleIds: Array<number> | undefined = ruleRef.current?.selectedRowKeys;
    onChange?.(_ruleIds);
  };

  const { data } = useRequest(() =>
    apiV2RuleRuleListPost({}).then(res => {
      return res.list;
    })
  );

  return (
    <>
      <Button type="link" size="small" disabled={!isEditing} onClick={() => setIsModalVisible(true)}>
        {value?.length ? '继续选择报警规则' : '请选择报警规则'}
      </Button>
      <div className={styles.value}>
        {value?.map(ruleId => {
          return (
            <Tag key={ruleId} closable={isEditing} className={styles.tag} onClose={e => onClose(e, ruleId)}>
              {data?.find(item => item.id === ruleId)?.name}
            </Tag>
          );
        })}
      </div>
      <Modal
        size="big"
        title="规则选择"
        open={isModalVisible}
        destroyOnClose
        onOk={onOk}
        onCancel={() => setIsModalVisible(false)}
      >
        <RuleModal ruleIds={value} ref={ruleRef} />
      </Modal>
    </>
  );
};

export default MultiRulesModalSelect;
